import { useEffect, useState } from 'react';

/**
 * Dynamically loads the Razorpay checkout.js script and returns { loaded }
 */
const useRazorpay = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (window.Razorpay) { setLoaded(true); return; }

    const existing = document.getElementById('razorpay-script');
    if (existing) {
      existing.addEventListener('load', () => setLoaded(true));
      return;
    }

    const script = document.createElement('script');
    script.id = 'razorpay-script';
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => setLoaded(true);
    script.onerror = () => console.error('Razorpay checkout.js failed to load');
    document.head.appendChild(script);
  }, []);

  return { loaded };
};

export default useRazorpay;
